<template>
    <div class="chart-component">
        <div v-if="selectingDatasets" class="select-container">
            <labelc v-for="(selection, index) in selectionLabels" :key="index" v-bind="selection" @Update="ToggleSelection(selection)"/>
            <buttonc type="primary" :label="'Load Chart'" @click="ToggleChart(true)"/>
        </div>
        <div v-if="!selectingDatasets" class="chart-container">
            <div class="selection-container" v-for="(selection, index) in groupSelectionLabels" :key="'g' + index">
                <labelc  v-bind="selection" type="small" @click="ToggleSelectionGroup(selection)"/>
                <labelc  v-for="(selectionLabel, index) in selectionLabels.filter(s => keyAxisGroupMap[s.key] && selection.value.find(v => v === s.key))" :key="index" v-bind="selectionLabel" type="small" @click="ToggleSelection(selectionLabel)"/>
            </div>                
            <labelc  v-for="(selectionLabel, index) in selectionLabels.filter(s => !keyAxisGroupMap[s.key])" :key="index" v-bind="selectionLabel" type="small" @click="ToggleSelection(selectionLabel)"/>

            <chartcontainer v-if="dataInit" :datasets="datasets" :options="optionsOverride"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "chartcomponent",
        data(){
            return {
                datasets: {},
                selectingDatasets: false,
                selectionLabels: [],
                groupSelectionLabels: [],
                selectionToggleDefault: false, 
                ColorMap: {},
                optionsDefault: {
                    elements: {
                        line: {tension: 0},
                        point:{radius: 0}
                    }, 
                    maintainAspectRatio: false, 
                    tooltips: {
                            mode: 'index', intersect: false,
                            callbacks: {
                                label: function(context) {
                                    return this._data.datasets[context.datasetIndex].label + ': ' +     this._data.datasets[context.datasetIndex].dataDisplay[context.index];
                                }
                            }
                    },
                    legend: {
                        display: false
                    },
                    plugins: {
                        tooltip: {
                        }
                    }
                },
                optionsOverride: {},
                contrastingColorList: [],
                dataInit: false,
            }
        },
        computed: {
            keyAxisGroupMap(){
                let map = {};
                Object.entries(this.axisGroups).forEach(e => e[1].forEach(i => map[i] = e[0]));
                return map;
            },
        },
        created(){
        
        },
        watch: {
            datasetsInit: {
                immediate: true,
                handler(oldVal, newVal){
                    let view = this;
                    if(this.dataTableState){
                         this.datasetsInit.updateChart = () => {
                            /*view.datasets.datasets = view.selectionLabels.map(d => {
                                return {
                                    yAxisID: d.key,
                                    label: d.text,  
                                    borderColor: d.color,
                                    color: d.color,
                                    hidden: d.toggled,
                                    data: view.dataTableState.data.map(row => {return view.dataTableState.headerMap[d.key].DisplayLabel(row)})
                                    
                                }
                            });
                            view.optionsOverride.scales = {yAxes: []};   
                            view.datasets.datasets.forEach(d => {
                                view.optionsOverride.scales.yAxes.push({
                                    id: view.selectionLabels.find(s => s.text === d.label).key,
                                    type: 'linear',
                                    display: false,
                                    position: 'left',
                                    ticks: {max: Math.max(...d.data.map(v => parseFloat(v))) * 1.1},
                                });
                                d.yAxisID = view.selectionLabels.find(s => s.text === d.label).key;
                            });
                            console.log(view.optionsOverride.scales);*/
                            view.datasets.datasets.forEach(d => {   
                                d.hidden = !view.selectionLabels.find(s => s.key === d.key).visible;
                            });
                            requestAnimationFrame(function(){
                                view.$children.find(d => d.$data._chart).$data._chart.update();
                            });
                        }; 
                    }
                    else {
                         this.datasetsInit.updateChart = () => {
                            view.InitDataset();
                            view.$children.find(d => d.$data._chart).$data._chart.update();
                        }
                    }
                    this.InitDataset();
                },
            },
            options: {
                immediate: true,
                handler(oldVal, newVal){
                    this.optionsOverride = {};
                    for(let key in this.optionsDefault){
                        this.optionsOverride[key] = this.optionsDefault[key];
                    }
                    for(let key in newVal){
                        this.optionsOverride[key] = newVal[key];
                    }
                },
            }
        },
        mounted(){
            let view = this;
        },
        props: {
            options: Object,
            datasetsInit: Object, 
            dataPoints: Array,
            dataTableState: Object,
            selectionToggleInit: Boolean,
            hiddenDataTableKeys: Array,
            dataTableSelectedDefault: Object,
            axisGroups: {
                type: Object,
                default: () => {return {}}
            },
            keyDataOverride: {
                type: Object,
                default: () => {return {}}
            },
            keyDisplayOverride: {
                type: Object,
                default: () => {return {}}
            },
        },
        methods: {
            GetRandomColor(selection){
                if(!this.ColorMap[selection.text]) {
                    this.ColorMap[selection.text] = this.contrastingColorList[this.selectionLabels.indexOf(selection)];
                }
                return this.ColorMap[selection.text];
            },
            ToggleChart(toggle){
                let view = this;
                this.selectingDatasets = !toggle;
                this.selectionLabels.forEach(s => {
                    s.visible = s.toggled;
                });
                view.datasets.datasets = view.selectionLabels.map(d => {
                    return {
                        yAxisID: this.keyAxisGroupMap[d.key] ? this.keyAxisGroupMap[d.key] : d.key,
                        key: d.key,
                        label: d.text,  
                        borderColor: d.color,
                        color: d.color,
                        hidden: !d.visible,
                        data: view.dataTableState.data.map(row => {return view.keyDataOverride[d.key] ? view.keyDataOverride[d.key](row) : view.dataTableState.headerMap[d.key].DisplayLabel(row) === '-' ? 0 : view.dataTableState.headerMap[d.key].DisplayLabel(row).toString().split('%').join('')}),
                        dataDisplay: view.dataTableState.data.map(row => {return view.keyDisplayOverride[d.key] ? view.keyDisplayOverride[d.key](row) : view.dataTableState.headerMap[d.key].DisplayLabel(row)})
                    }
                });
                view.optionsOverride.scales = {yAxes: []};   
                view.selectionLabels.forEach(d => {
                    let valMap = view.datasets.datasets.find(set => set.key === d.key).data.filter(d => !isNaN(parseFloat(d))).map(v => parseFloat(v));
                    let min = Math.min(...valMap);
                    if(min < 0) min *= 1.1;
                    else min = 0;
                    if(view.keyAxisGroupMap[d.key]){
                        if(!view.optionsOverride.scales.yAxes.find(axis => view.keyAxisGroupMap[d.key] === axis.id)){
                            valMap = [];
                            view.datasets.datasets.filter(set => view.keyAxisGroupMap[set.key] === view.keyAxisGroupMap[d.key]).forEach(m => valMap = valMap.concat(m.data.filter(d => !isNaN(parseFloat(d))).map(v => parseFloat(v))));
                            min = Math.min(...valMap);
                            if(min < 0) min *= 1.1;
                            else min = 0;
                            view.optionsOverride.scales.yAxes.push({
                                id: view.keyAxisGroupMap[d.key],
                                type: 'linear',
                                display: false,
                                position: 'left',
                                ticks: {max: Math.max(...valMap) * 1.1, min: min},
                            });
                        }
                    }else{
                        view.optionsOverride.scales.yAxes.push({
                            id: d.key,
                            type: 'linear',
                            display: false,
                            position: 'left',
                            ticks: {max: Math.max(...valMap) * 1.1, min: min},
                        });
                    }
                    if(view.optionsOverride.scales.yAxes[view.optionsOverride.scales.yAxes.length - 1].ticks.max < 1) view.optionsOverride.scales.yAxes[view.optionsOverride.scales.yAxes.length - 1].ticks.max = 1;
                });
            },
            ToggleSelection(selection){
                let view = this;
                if(!this.selectingDatasets) {
                    selection.visible = !selection.visible;
                    selection.checkbox = {value: selection.visible, colorChecked: selection.color, colorUnchecked: selection.color.replace(')', ' / 50%)')};
                    this.datasetsInit.updateChart();
                }
                else {
                    selection.checkbox.value = selection.toggled = !selection.toggled;
                    this.datasets.datasets = this.selectionLabels.filter(d => d.toggled).map(d => {
                        return {
                            label: d.text,  
                            data: view.dataTableState.data.map(row => {return view.dataTableState.headerMap[d.key].DisplayLabel(row)})
                        }
                    });
                }
            },
            ToggleSelectionGroup(selection){
                let view = this;
                if(!this.selectingDatasets) {
                    selection.visible = !selection.visible;
                    //console.log(selection);
                    selection.checkbox = {value: selection.visible, colorChecked: selection.color, colorUnchecked: selection.color.replace(')', ' / 50%)')};
                    this.selectionLabels.filter(s => view.keyAxisGroupMap[s.key] && selection.value.find(v => v === s.key)).forEach(s => {
                            s.visible = selection.visible;
                            s.hide = !s.visible;
                            s.checkbox = {value: s.visible, colorChecked: s.color, colorUnchecked: s.color.replace(')', ' / 50%)')};
                    });
                    this.datasetsInit.updateChart();
                    this.$forceUpdate();
                }
                else {
                    selection.checkbox.value = selection.toggled = !selection.toggled;
                    this.datasets.datasets = this.selectionLabels.filter(d => d.toggled).map(d => {
                        return {
                            label: d.text,  
                            data: view.dataTableState.data.map(row => {return view.dataTableState.headerMap[d.key].DisplayLabel(row)})
                        }
                    });
                }
            },
            SelectionLabelFromDatatableEntry(entry){
                let key = entry[0];
                let val = entry[1];
                let label = {
                    text: val.label, type: 'block checkbox-label', 
                    key: key,
                    value: val,
                    toggled: this.dataTableSelectedDefault ? this.keyAxisGroupMap[key] ? this.dataTableSelectedDefault[this.keyAxisGroupMap[key]] : this.dataTableSelectedDefault[key] : this.hasOwnProperty('selectionToggleDefault') ? this.selectionToggleDefault : false,
                    };
                    
                if(this.contrastingColorList.length === 0){
                    for(let x = 2; x < 20; x++){
                        this.contrastingColorList.push('hsl(' + ((x * 76) % 360) + 'deg ' + (((x * 22) % 100) + 40) + '% ' + (((x * 33) % 60) + 20) + '%)');
                    }
                }
                
                label.borderColor = label.color = this.contrastingColorList[Object.entries(this.dataTableState.headerMap).findIndex(i => i[0] === label.key)];
                label.checkbox = {value: label.toggled, colorChecked: label.color, colorUnchecked: label.color.replace(')', ' / 50%)')};
                label.visible = label.toggled;
                return label;
            },
            SelectionLabelFromAxisGroup(entry){
                let key = entry[0];
                let val = entry[1];
                let label = {
                    text: key, type: 'block checkbox-label', 
                    key: key,
                    value: val,
                    toggled: this.dataTableSelectedDefault ? this.dataTableSelectedDefault[key] : this.hasOwnProperty('selectionToggleDefault') ? this.selectionToggleDefault : false,
                    };
                    
                if(this.contrastingColorList.length === 0){
                    for(let x = 2; x < 20; x++){
                        this.contrastingColorList.push('hsl(' + ((x * 76) % 360) + 'deg ' + (((x * 22) % 100) + 40) + '% ' + (((x * 33) % 60) + 20) + '%)');
                    }
                }
                
                label.borderColor = label.color = this.contrastingColorList[Object.entries(this.axisGroups).findIndex(i => i[0] === key)];
                label.checkbox = {value: label.toggled, colorChecked: label.color, colorUnchecked: label.color.replace(')', ' / 50%)')};
                label.visible = label.toggled;
                return label;
            },
            InitDataset(skipSelect){
                let view = this;
                if(this.dataTableState){
                    //this.selectingDatasets = true;
                    this.groupSelectionLabels = Object.entries(this.axisGroups).map(e => view.SelectionLabelFromAxisGroup(e));
                    this.selectionLabels = Object.entries(this.dataTableState.headerMap).filter(e => e[1].label && (!view.hiddenDataTableKeys || !view.hiddenDataTableKeys.find(k => k === e[0]))).map(e => view.SelectionLabelFromDatatableEntry(e));
                    this.datasets.labels = this.dataPoints.map(d => view.datasetsInit.DisplayLabel(d));
                    this.datasets.datasets = this.selectionLabels.map(d => {
                        return {
                            yAxisID: view.keyAxisGroupMap[d.key] ? view.keyAxisGroupMap[d.key] : d.key,
                            key: d.key,
                            label: d.text,  
                            borderColor: d.color,
                            color: d.color,
                            hidden: !d.toggled,
                            data: view.dataTableState.data.map(row => {return view.keyDataOverride[d.key] ? view.keyDataOverride[d.key](row) : view.dataTableState.headerMap[d.key].DisplayLabel(row) === '-' ? 0 : view.dataTableState.headerMap[d.key].DisplayLabel(row).toString().split('%').join('')}),
                            dataDisplay: view.dataTableState.data.map(row => {return view.keyDisplayOverride[d.key] ? view.keyDisplayOverride[d.key](row) : view.dataTableState.headerMap[d.key].DisplayLabel(row)})
                        }
                    });
                    requestAnimationFrame(function(){
                        view.optionsOverride.scales = {yAxes: []};   
                        view.selectionLabels.forEach(d => {
                            let valMap = view.datasets.datasets.find(set => set.key === d.key).data.filter(d => !isNaN(parseFloat(d))).map(v => parseFloat(v));
                            let min = Math.min(...valMap);
                            if(min < 0) min *= 1.1;
                            else min = 0;
                            if(view.keyAxisGroupMap[d.key]){
                                if(!view.optionsOverride.scales.yAxes.find(axis => view.keyAxisGroupMap[d.key] === axis.id)){
                                    valMap = [];
                                    view.datasets.datasets.filter(set => view.keyAxisGroupMap[set.key] === view.keyAxisGroupMap[d.key]).forEach(m => valMap = valMap.concat(m.data.filter(d => !isNaN(parseFloat(d))).map(v => parseFloat(v))));
                                    min = Math.min(...valMap);
                                    if(min < 0) min *= 1.1;
                                    else min = 0;
                                    view.optionsOverride.scales.yAxes.push({
                                        id: view.keyAxisGroupMap[d.key],
                                        type: 'linear',
                                        display: false,
                                        position: 'left',
                                        ticks: {max: Math.max(...valMap) * 1.1, min: min},
                                    });
                                }
                            }else{
                                view.optionsOverride.scales.yAxes.push({
                                    id: d.key,
                                    type: 'linear',
                                    display: false,
                                    position: 'left',
                                    ticks: {max: Math.max(...valMap) * 1.1, min: min},
                                });
                            }
                            if(view.optionsOverride.scales.yAxes[view.optionsOverride.scales.yAxes.length - 1].ticks.max < 1) view.optionsOverride.scales.yAxes[view.optionsOverride.scales.yAxes.length - 1].ticks.max = 1;
                        });
                        requestAnimationFrame(function(){
                            view.dataInit = true;
                        });
                    });
                }
                else {
                    this.selectingDatasets = false;
                    this.datasets.labels = this.dataPoints.map(d => view.datasetsInit.DisplayLabel(d));
                    this.datasets.datasets = view.datasetsInit.datasetsList.filter(d => d.toggled).map(d => {
                        return {
                            label: d.text,  
                            borderColor: d.color,
                            data: view.dataPoints.map(p => {return d.dataLoad(p)}),
                            toggled: d.toggled,
                        }
                    });
                    this.dataInit = true;
                }
            },
            OpenFilterDropdown($event){
                let view = this;
                let target = $event.currentTarget;
                if(this.dataTableState){
                    this.selectionLabels.forEach(d => {
                        d.type = 'block small';
                        d.iconLeft = {icon: 'fa-circle', styleIcon: {color: d.color}};
                        d.styleText = {'padding-right': '15px'};
                        d.iconRight = {icon: 'fa-circle', styleIcon: {color: d.visible ? '#6d8d23' : 'var(--contrast-2)', transform: "scale(.7)"}, styleButton: {position: 'absolute', right: "5px", top: 0, bottom: 0, margin: 'auto'}};
                        
                        d.click = function(){
                                d.visible = !d.visible;
                                d.iconRight.styleIcon = {color: d.visible ? '#6d8d23' : 'var(--contrast-2)', transform: "scale(.7)"};
                                view.datasetsInit.updateChart();
                            }
                    });
                }else{
                    this.datasetsInit.datasetsList.forEach(d => {
                        d.type = 'block small';
                        d.iconLeft = {icon: 'fa-circle', styleIcon: {color: d.color}};
                        d.styleText = {'padding-right': '15px'};
                        d.iconRight = {icon: 'fa-circle', styleIcon: {color: d.toggled ? '#6d8d23' : 'var(--contrast-2)', transform: "scale(.7)"}, styleButton: {position: 'absolute', right: "5px", top: 0, bottom: 0, margin: 'auto'}};
                        d.click = function(){
                                d.toggled = !d.toggled;
                                d.iconRight = {icon: 'fa-circle', styleIcon: {color: d.toggled ? '#6d8d23' : 'var(--contrast-2)', transform: "scale(.7)"}, styleButton: {position: 'absolute', right: "5px", top: 0, bottom: 0, margin: 'auto'}};let found = view.selectionLabels.find(s => s.text === d.text);
                                if(found) found.toggled = d.toggled;
                                view.datasetsInit.updateChart();
                            }
                    });
                }

                this.$helpers.OpenPopup({
                    elRelative: target,
                    type: 'listlabel',
                    componentState: {
                        labels: this.dataTableState ? this.selectionLabels.filter(s => s.toggled) : this.datasetsInit.datasetsList,
                        remainAfterSelect: true,
                    },
                    remainAfterSelect: true,
                    pointerDirection: 0,
                    iconsLeft: true,
                    disableCloseIcon: true,
                    noScroll: true,
                });
            },
        },
    }
</script>

<style scoped>

.chart-component{
    width: min-content;
    min-width: 250px;
}

.select-container{
    display: flex;
    flex-wrap: wrap;;
    padding-bottom: 40px;
    
}

.chart-container > .button{
    height: 25px;
    width: 25px;
    float: left;
}

.select-container > .button{
    position: absolute;
    bottom: 50px;
    right: 50px;
}

.chart-container > div:last-child{
    width: calc(100vw - 200px);
    height: calc(100vh - 140px);
    margin-top: 20px;
}

.selection-container{
    display: inline-block;
    box-shadow: inset -2px 0 0 -1px  var(--contrast-3);
    padding-right: 5px;
}

.selection-container > div:first-child{
    display: flex;
    user-select: none;
}

.selection-container > div:not(:first-child){
    user-select: none;
}

.chart-container > .label{
    vertical-align: top;
    user-select: none;
}
</style>
